/**
 * DTOs OutboxEvents — guide v2.5 §6.x (contrat uniforme sur les 6 services
 * admin / fee-engine / kyc / ledger / merchant / wallet).
 */

/** Statuts de la boîte d'envoi (docs/SI/03). */
export const OUTBOX_EVENT_STATUSES = [
  "PENDING",
  "PROCESSING",
  "DONE",
  "DEAD_LETTER",
] as const;
export type OutboxEventStatus = (typeof OUTBOX_EVENT_STATUSES)[number];

/**
 * Événement dans la boîte d'envoi. Les champs exposés par les 6 services
 * sont alignés (contrat uniforme). `payload` sérialisé JSON côté serveur.
 */
export interface OutboxEventDto {
  id: string;
  topic: string;
  status: OutboxEventStatus;
  aggregateId?: string | null;
  aggregateType?: string | null;
  payload?: string | Record<string, unknown> | null;
  attempts?: number;
  nextRetryAt?: string | null;
  lastErrorMessage?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

/** Corps de `POST /OutboxEvents/{id}/replay`. */
export interface ReplayOutboxEventRequest {
  /** Motif libre (traçabilité). */
  reason: string;
}
